'use client';

import { __styles, mergeClasses } from "@griffel/react";
import { typographyStyles } from "@fluentui/react-theme";
export const navSectionHeaderClassNames = {
  root: 'fui-NavSectionHeader'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    Jyy4pa: "f1gr6hdk",
    Bo78w4l: 0,
    Cgygva: 0,
    yil37a: "f1ulrxyd",
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fwrc4pm"
  }
}, {
  d: [".f1gr6hdk{-webkit-margin-start:10px;margin-inline-start:10px;}", [".f1ulrxyd{margin-block:8px;}", {
    p: -1
  }], ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}"]
});
/**
 * Apply styling to the NavSectionHeader slots based on the state
 */
export const useNavSectionHeaderStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(navSectionHeaderClassNames.root, styles.root, state.root.className);
  return state;
};